import Firebase from "firebase";
import VueCookies from "vue-cookies";

const state = {
  associacao: null,
  isSuccess: false,
  requireUpdate: true
};

const mutations = {
  setAssociacao(state, payload) {
    state.associacao = payload;
  },
  setIsSuccess(state, payload) {
    state.isSuccess = payload;
  },
  setRequireUpdate(state, payload) {
    state.requireUpdate = payload;
  }
};

const actions = {
  getAssociacaoInFirestore: async ({ commit }) => {
    let _associacao = VueCookies.get("IDASSOCIACAO");
    if (!state.requireUpdate) return;

    if (_associacao) {
      await Firebase.firestore()
        .collection("associacoes")
        .doc(_associacao)
        .get()
        .then(doc => {
          let associacao = doc.data();
          //Buscar sócios pela referência no Firestore
          let sociosAtivos = [];
          let sociosArquivados = [];

          associacao.socios.ativos.forEach(data => {
            data.get().then(socio => {
              sociosAtivos.push(socio.data());
            });
          });

          associacao.socios.arquivados.forEach(data => {
            data.get().then(socio => {
              sociosArquivados.push(socio.data());
            });
          });

          associacao.socios.ativos = sociosAtivos;
          associacao.socios.arquivados = sociosArquivados;

          commit("setAssociacao", associacao);
          commit('setRequireUpdate', false);
        });
    }
  },

  addReferenceOfPartnerInFirestore: async (context, partnerId) => {
    let socioRef = Firebase.firestore()
      .collection("associados")
      .doc(partnerId);
    let _associacao = VueCookies.get("IDASSOCIACAO");

    await Firebase.firestore()
      .collection("associacoes")
      .doc(_associacao)
      .update({
        "socios.ativos": Firebase.firestore.FieldValue.arrayUnion(socioRef)
      })
      .then(() => {
        console.log("Coleção Associações Atualizada");
        context.commit("setRequireUpdate", true);
      })
      .catch(() => {
        console.log("Erro ao atualizar a coleção");
      });

      context.dispatch('getAssociacaoInFirestore')
  },

  archivePartnerInFirestore: async (context, partnerId) => {
    let socioRef = Firebase.firestore()
      .collection("associados")
      .doc(partnerId);
    let _associacao = VueCookies.get("IDASSOCIACAO");

    await Firebase.firestore()
      .collection("associacoes")
      .doc(_associacao)
      .update({
        "socios.ativos": Firebase.firestore.FieldValue.arrayRemove(socioRef),
        "socios.arquivados": Firebase.firestore.FieldValue.arrayUnion(socioRef)
      })
      .then(() => {
        console.log("Success");
        context.commit("setIsSuccess", true);
        context.commit("setRequireUpdate", true);
      })
      .catch(error => {
        console.log("Error", error);
        context.commit("setIsSuccess", false);
      });

      context.dispatch('getAssociacaoInFirestore')
  },

  unarchivePartnerInFirestore: async (context, partnerId) => {
    let socioRef = Firebase.firestore()
      .collection("associados")
      .doc(partnerId);
    let _associacao = VueCookies.get("IDASSOCIACAO");

    await Firebase.firestore()
      .collection("associacoes")
      .doc(_associacao)
      .update({
        "socios.ativos": Firebase.firestore.FieldValue.arrayUnion(socioRef),
        "socios.arquivados": Firebase.firestore.FieldValue.arrayRemove(socioRef)
      })
      .then(() => {
        console.log("Success");
        context.commit("setIsSuccess", true);
        context.commit("setRequireUpdate", true);
      })
      .catch(error => {
        console.log("Error", error);
        commit("setIsSuccess", false);
      });

      context.dispatch('getAssociacaoInFirestore')
  }
};

const getters = {
  getAssociacao: state => state.associacao,
  getIsSuccess: state => state.isSuccess
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
